import React, { useEffect, useState } from 'react';
import { BASE_URL } from '../config/api'; // Assuming BASE_URL is correctly defined in your config/api.js
import { useNavigate, useParams } from 'react-router-dom';

const EditCatalogue = () => {
    const { id } = useParams(); // Get the catalogue ID from the URL
    const [catalogue, setCatalogue] = useState(null);
    const [categories, setCategories] = useState([]);
    const [subCategories, setSubCategories] = useState([]);
    const [categoryId, setCategoryId] = useState('');
    const [subCategoryId, setSubCategoryId] = useState('');
    const [weight, setWeight] = useState('');
    const [image, setImage] = useState(null);
    const navigate = useNavigate();

    // Fetch the catalogue details to be edited
    useEffect(() => {
        // Fetch catalogue data
        fetch(`${BASE_URL}Catalogue/${id}`)
            .then(response => response.json())
            .then(data => {
                if (data.status === 1) {
                    const catalogueData = data.data;
                    setCatalogue(catalogueData);
                    setCategoryId(catalogueData.category_id); // Set the old category ID
                    setSubCategoryId(catalogueData.sub_category_id); // Set the old subcategory ID
                    setWeight(catalogueData.weight);
                    setImage(catalogueData.image);
                } else {
                    alert('Error fetching catalogue');
                }
            })
            .catch(error => console.error('Error fetching catalogue:', error));

        // Fetch categories
        fetch(`${BASE_URL}categories`)
            .then(response => response.json())
            .then(data => {
                if (data.status === 1) {
                    setCategories(data.data); // Set categories data
                } else {
                    alert('Error fetching categories');
                }
            })
            .catch(error => console.error('Error fetching categories:', error));

        // Fetch subcategories
        fetch(`${BASE_URL}subcategories`)
            .then(response => response.json())
            .then(data => {
                if (data.status === 1) {
                    setSubCategories(data.data); // Set subcategories data
                } else {
                    alert('Error fetching subcategories');
                }
            })
            .catch(error => console.error('Error fetching subcategories:', error));
    }, [id]);

    // Handle form submission to update the catalogue
    const handleSubmit = (e) => {
        e.preventDefault();

        const updatedCatalogue = {
            category_id: 1,
            sub_category_id: subCategoryId,
            weight: 11,
            image: image, // Add image handling if needed
        };

        // Send the updated data to the API
        fetch(`${BASE_URL}Catalogue/${id}`, {
            method: 'PUT', // Or 'PATCH' if appropriate
            headers: {
                'Content-Type': 'application/json',
            },
            body: JSON.stringify(updatedCatalogue),
        })
            .then(response => response.json())
            .then(data => {
                if (data.status === 1) {
                    alert('Catalogue updated successfully!');
                    navigate('/CatalogueList'); // Navigate back to catalogue list
                } else {
                    alert('Error updating catalogue');
                }
            })
            .catch(error => console.error('Error updating catalogue:', error));
    };

    // Handle image upload if necessary
    const handleImageChange = (e) => {
        setImage(e.target.files[0]);
    };

    return (
        <div id="main">
            <header className="mb-3">
                <a href="#" className="burger-btn d-block d-xl-none">
                    <i className="bi bi-justify fs-3"></i>
                </a>
            </header>

            <div className="page-heading">
                <div className="page-title">
                    <div className="row">
                        <div className="col-12 col-md-6 order-md-1 order-last">
                            <h3>Edit Forming Catalogue</h3>
                        </div>
                        <div className="col-12 col-md-6 order-md-2 order-first">
                            <nav aria-label="breadcrumb" className="breadcrumb-header float-start float-lg-end">
                                <ol className="breadcrumb"></ol>
                            </nav>
                        </div>
                    </div>
                </div>
            </div>

            {/* Edit Catalogue Form */}
            <section className="section">
                <div className="row">
                    <div className="col-12">
                        <div className="card">
                            <div className="card-header">
                                <h4>Edit Forming Catalogue Details</h4>
                            </div>
                            <div className="card-body">
                                <form onSubmit={handleSubmit}>
                                    {/* Category Dropdown */}
                                    {/* <div className="mb-3">
                                        <label htmlFor="categoryId" className="form-label">Category</label>
                                        <select
                                            id="categoryId"
                                            className="form-control"
                                            value={categoryId}
                                            onChange={(e) => setCategoryId(e.target.value)}
                                        >
                                            <option value="">Select Category</option>
                                            {categories.map((category) => (
                                                <option key={category.id} value={category.id}>
                                                    {category.name}
                                                </option>
                                            ))}
                                        </select>
                                    </div> */}

                                    {/* Subcategory Dropdown */}
                                    <div className="mb-3">
                                        <label htmlFor="subCategoryId" className="form-label">Subcategory</label>
                                        <select
                                            id="subCategoryId"
                                            className="form-control"
                                            value={subCategoryId}
                                            onChange={(e) => setSubCategoryId(e.target.value)}
                                        >
                                            <option value="">Select Subcategory</option>
                                            {subCategories.map((subCategory) => (
                                                <option key={subCategory.id} value={subCategory.id}>
                                                    {subCategory.name}
                                                </option>
                                            ))}
                                        </select>
                                    </div>

                                    {/* Weight Input */}
                                    {/* <div className="mb-3">
                                        <label htmlFor="weight" className="form-label">Weight</label>
                                        <input
                                            type="text"
                                            id="weight"
                                            className="form-control"
                                            value={weight}
                                            onChange={(e) => setWeight(e.target.value)}
                                            required
                                        />
                                    </div> */}

                                    {/* Image Input (if needed) */}
                                    <div className="mb-3">
                                        <label htmlFor="image" className="form-label">Image</label>
                                        <input
                                            type="file"
                                            id="image"
                                            className="form-control"
                                            onChange={handleImageChange}
                                        />
                                        {image && <p>Selected Image: {image.name}</p>}
                                    </div>

                                    {/* Submit Button */}
                                    <div className="text-end">
                                        <button type="submit" className="btn btn-primary">
                                            Update Catalogue
                                        </button>
                                    </div>
                                </form>
                            </div>
                        </div>
                    </div>
                </div>
            </section>
        </div>
    );
};

export default EditCatalogue;
